module.exports = __webpack_public_path__ + "img/upload_bg@3x.56731812.png";